import { useCallback } from "react";

const useAffordabilityLegends = ({ indicatorData, existingLegends, newCountryName, affordAdmin,}) => {
  const getAffordLegends = useCallback(() => {
    const affordCategory = indicatorData?.affordabilityCategory?.split("_")?.join(".");

    const ituAffordLegendData = existingLegends?.find((legend) => {
      return legend?.name === `${newCountryName}-${affordAdmin}-${affordCategory}`;
    });

    return ituAffordLegendData?.data;
  }, [newCountryName, affordAdmin, existingLegends, indicatorData?.affordabilityCategory]);

  const affordabilityLegends = getAffordLegends();

  return { affordabilityLegends };
};

export default useAffordabilityLegends;
